import React, { useState, useEffect, useContext } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { RecoveryContext } from '../recoveryContext';
import { useStores } from 'hooks/useStores';
import { INVALIDATION_TIP } from "../../../const/validation";

const schema = yup.object().shape({
	code: yup
		.string()
		.required(INVALIDATION_TIP.FIELD_REQUIRED )
		.matches(/^\d+$/, INVALIDATION_TIP.INCORRECT_CODE)
		.min(6, INVALIDATION_TIP.INCORRECT_CODE_LENGTH)
		.max(6, INVALIDATION_TIP.INCORRECT_CODE_LENGTH),
});

export default function RecoveryStep2(props) {
	const { contextEmail } = useContext(RecoveryContext);
	const [wrongError, setWrongError] = useState();
	const [response, setResponse] = useState({ status: false });
  const { api } = useStores()

	const changeStep = () => {
		props.nextStep(3);
	};

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm({
		mode: 'onBlur',
		resolver: yupResolver(schema),
	});

	const onSubmit = data => {
		setWrongError(undefined)
    api.auth.postRestorePassword({
      email: contextEmail,
      code: data.code,
    },)
			.then(res => {
				setResponse(res);
			})
			.catch(err => {
				setWrongError(err.response.data.message);
			});
	};

	useEffect(() => {
		if (response.status === true) changeStep();
	}, [response]);

	return (
		<div>
			<h3 className='lkLogin-main__step'>Шаг 2</h3>
			<h1 className='lkLogin-main__title'>Восстановление</h1>
			<h4 className='lkLogin-main__subtitle'>
				Вам на почту был отправлен код подтверждения для смены пароля
			</h4>
			{wrongError !== undefined && (
				<div className='lkLogin-incorrectLogin'>
        {wrongError}
				</div>
			)}
			<form className='lkLogin-form' onSubmit={handleSubmit(onSubmit)}>
				<div className='lkLogin-form-item'>
					<label htmlFor='code'>
						Введите код<span className='lkLogin-form__span'>*</span>
					</label>
					<input
						autoFocus
						{...register('code')}
						id='code'
						name='code'
						type='text'
						className='lkLogin-input'
					/>
					<p className='lkLogin-form__err'>{errors.code?.message}</p>
				</div>
				<div>
					<button className='lkLogin-form-btn lkLogin-form-item' type='submit'>
						Отправить
					</button>
				</div>
			</form>
		</div>
	);
}
